module.exports = __webpack_public_path__ + "img/contacts.3e46b7c5.png";